'use strict'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'

const httpAL = {
  'nl-BE': 'nl-BE, nl; 0.9, en; 0.8',
  'nl': 'nl, en; 0.8',
  'fr-BE': 'fr-BE, fr; 0.9, en; 0.8',
  'fr': 'fr, en; 0.8',
  'de': 'de, en; 0.8',
  'en': 'en',
}

export default {
  setLocale: function(locale) {
    console.log('set locale', locale)
    Vue.i18n.locale = locale
    moment.locale(locale)
    Vue.http.headers.common['Accept-Language'] = httpAL[locale]
  },

  getMonths: function() {
    return [
      Vue.i18n.t('month.jan'),
      Vue.i18n.t('month.feb'),
      Vue.i18n.t('month.mar'),
      Vue.i18n.t('month.apr'),
      Vue.i18n.t('month.may'),
      Vue.i18n.t('month.jun'),
      Vue.i18n.t('month.jul'),
      Vue.i18n.t('month.aug'),
      Vue.i18n.t('month.sep'),
      Vue.i18n.t('month.oct'),
      Vue.i18n.t('month.nov'),
      Vue.i18n.t('month.dec'),
    ]
  },
  getDays: function() {
    return [
      Vue.i18n.t('day.mo'),
      Vue.i18n.t('day.tu'),
      Vue.i18n.t('day.we'),
      Vue.i18n.t('day.th'),
      Vue.i18n.t('day.fr'),
      Vue.i18n.t('day.sa'),
      Vue.i18n.t('day.su'),
    ]
  },

  initI18n: function() {
    Vue.use(VueI18n)

    const messages = {
      en: require('/locales/files/en.json'),
      de: require('/locales/files/de.json'),
      nl: require('/locales/files/nl.json'),
      'nl-BE': require('/locales/files/nl-BE.json'),
      fr: require('/locales/files/fr.json'),
      'fr-BE': require('/locales/files/fr-BE.json'),
    }

    // derive locale
    let locale = 'en'

    let languages = navigator.languages || [navigator.language] || ['en']
    languages.some(language => {
      if (messages[language]) {
        locale = language
        return true
      }
      const lang = language.split('-')[0]
      if (messages[lang]) {
        locale = lang
        return true
      }
      return false
    })

    // Create VueI18n instance with options
    let i18n = new VueI18n({
      locale,
      messages,
      silentTranslationWarn: true,
    })
    Vue.i18n = i18n
    return i18n
  }
}
